import React from 'react';
import {
  ServiceLink,
  ServiceIcon,
  ServiceContent,
  ServiceEyebrow,
  ServiceAction,
  ServicesSectionContainer,
  ServicesHeader,
  ServicesDescription,
  ServicesContainer,
  EachService,
  ServicesIntro,
} from './Services.styles';
import { services } from './Services';

const ServicesSection = () => {
  return (
    <ServicesSectionContainer>
      <ServicesIntro>
        <p className="eyebrowHeader">What We Offer</p>
        <ServicesHeader>
          Safety Solutions Built for Real Workplaces
        </ServicesHeader>

        <ServicesDescription>
          We provide audits, training, industry resources, and contractor
          management support for businesses across Atlantic Canada.
        </ServicesDescription>
      </ServicesIntro>

      <ServicesContainer>
        {services.map((service, idx) => (
          <ServiceLink to={service.link} key={idx}>
            <EachService>
              <ServiceIcon>{service.icon}</ServiceIcon>

              <ServiceContent>
                <ServiceEyebrow>{service.eyebrow}</ServiceEyebrow>

                <h4>{service.title}</h4>

                <p>{service.description}</p>

                <ServiceAction>
                  {service.buttonText}
                  <span aria-hidden="true">→</span>
                </ServiceAction>
              </ServiceContent>
            </EachService>
          </ServiceLink>
        ))}
      </ServicesContainer>
    </ServicesSectionContainer>
  );
};

export default ServicesSection;
